import { DialogModule } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { GlobalAddButtonsComponent } from '@app/global-add/components/global-add-buttons/global-add-buttons.component';
import { SearchSharedModule } from '@app/search/search-shared.module';

import { LayoutModule_v1 } from '../../v1';
import { AddContentComponent } from './add-content/add-content.component';
import { SearchComponent } from './search/search.component';

import { SearchAutocompleteDataService } from '@app/search/components/search-initiation-autocomplete/search-autocomplete.data-service';
import { SearchAutocompleteFacade } from '@app/search/components/search-initiation-autocomplete/search-autocomplete.facade';
import { SearchFieldWrapperComponent } from '@app/shared/components/search/search-field-wrapper/search-field-wrapper.component';
import { IconComponent, SpinnerComponent } from '@degreed/apollo';
import { BypassSecurityPipe } from '@degreed/core/pipes';
import { ActionButtonComponent } from '@degreed/lxp/ui';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    SpinnerComponent,
    GlobalAddButtonsComponent,
    SearchSharedModule,
    RouterModule,
    LayoutModule_v1,
    BypassSecurityPipe,
    ActionButtonComponent,
    SearchFieldWrapperComponent,
    IconComponent,
  ],
  declarations: [AddContentComponent, SearchComponent],
  providers: [SearchAutocompleteFacade, SearchAutocompleteDataService],
})
export class LayoutModule_v3 {}
